import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit } = measures

export const buttonContainer = css`
  text-align: center;
`

export const loginButton = css`
  width: 50%;
  margin-left: ${unit}px;
`

export const controlWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const forgotPasswordBlock = css`
  width: 80px;
  > a > span:hover {
    color: ${colors.greens.green6};
  }
`

export const regBeneWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  > a > span:hover {
    color: ${colors.greens.green6};
  }
`

export const separator = css`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${colors.grays.gray4};
  }

  &::before {
    margin-right: .5em;
  }

  &::after {
    margin-left: .5em;
  }
`

export const separatorText = css`
  font-size: 14px;
  color: ${colors.grays.gray3};
`

export const googleButton = css`
  width: 100%;
  background-color: transparent !important;
  border: 1px solid ${colors.grays.gray4} !important;
  display: flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${colors.grays.gray5} !important;
  }
`

export const googleIcon = css`
  margin-right: 10px;
  font-size: 18px;
  color: white;
`
